import certificate from '../resources/imgs/certificates.webp'

const Photovoltaic = () => {
  return (
    <div className='pv'>
      <div className='pv-l'>
        <div className='pv-l-title'>Fotovoltaická elektrárna</div>
        <div className='pv-l-info'>
          Hlavním cílem projektu je zvýšení energetické účinnosti výrobního
          procesu. Dílčími cíli jsou úspora elektrické energie, částečná
          energetická soběstačnost, efektivnější využití elektrické energie,
          snížení emisí oxidu uhličitého, tuhých znečišťujících látek a dalších
          emisních faktorů. Žadatel, společnost CNC obrábění DUBEN, spol. s
          r.o., realizoval projekt v termínu od 1.1.2022 do 25.4.2022.
        </div>
        <div className='pv-l-title pv-l-mar-t'>Fotovoltaická elektrárna II</div>
        <div className='pv-l-info'>
          Cílem projektu je instalace fotovoltaické elektrárny (bez akumulace)
          sloužící pro vlastní spotřebu žadatele. Za pomoci využití
          obnovitelných zdrojů dojde k optimalizaci zajištění elektrické energie
          pro podnikatelskou činnost.
        </div>
      </div>
      <div className='pv-r'>
        <img src={certificate} alt='Dotace EU' className='pv-r-img' />
      </div>
    </div>
  )
}

export default Photovoltaic
